const relevantYearsOfWorkExperience = ['None', '1-3', '3-5', '5+'];
export default relevantYearsOfWorkExperience;
